// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5828) return "css/5828-cac3387d.css";
	// return url for filenames based on template
	return "css/" + "styles" + "-" + "ad727c32" + ".css";
};